import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Stack } from '../../shared/stack/Stack'
import { Typography } from '../../shared/typography/typography'
import { FooterContactActions } from './footer-contact-actions'
import { FooterContactImage } from './footer-contact-image'

export type FooterContactProps = {
  headline: string
  overline: string
  image: string
  name: string
  email: string
  phone: string
}

export const FooterContact = forwardRef(function FooterContact(
  { image, name, headline, overline, email, phone, ...props },
  ref,
) {
  return (
    <Stack
      direction={{ sm: 'column', md: 'row' }}
      align="center"
      gap={4 * 8}
      {...props}
      ref={ref}
    >
      <FooterContactImage name={name} image={image} />
      <Stack direction="column" gap={4 * 12} className="flex-1">
        <div>
          <Typography
            scale="overline"
            emphasis="default"
            className="text-center md:text-start"
          >
            {overline}
          </Typography>
          <Typography
            as="h3"
            scale="h3"
            emphasis="strong"
            className="mt-4 text-center md:text-start"
          >
            {headline}
          </Typography>
        </div>
        <FooterContactActions email={email} phone={phone} />
      </Stack>
    </Stack>
  )
}) as Polymorphic<'div', FooterContactProps>
